// @ts-ignore
import { findIn } from "@elements/dom-utils";
// @ts-ignore
import { initInScope } from "@elements/init-modules-in-scope";
export function renderTemplate(renderItem, selectors) {
    let template = findIn(selectors.template, renderItem);
    if (template) {
        if (renderItem.parentElement) { // add this check to prevent parent being null
            let parent = renderItem.parentElement;
            //everything about the overlay will be overwritten
            parent.innerHTML = template.innerHTML;
            initInScope(parent);
        }
        else {
            console.error("renderItem does not have a parent element");
        }
    }
}
